<template>
  <div
    class="layout"
    v-if="account"
  >
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <template v-slot:prepend>
        <v-list-item class="py-2">
          <v-list-item-avatar
            color="indigo"
          >
            <v-icon dark>person</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ account.firstname }} {{ account.lastname }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:append>
        <v-divider></v-divider>

        <v-list-item
          dense
          @click="logout()"
        >
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list
        dense
      >
        <v-list-item
          v-for="item in globals"
          :key="item.title"
          :to="{ name: item.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list
        dense
        subheader
      >
        <v-subheader>Categorization</v-subheader>

        <v-list-item
          v-for="item in categorization"
          :key="item.title"
          :to="{ name: item.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list
        dense
        subheader
      >
        <v-subheader>Admin</v-subheader>

        <v-list-item
          v-for="item in admin"
          :key="item.title"
          :to="{ name: item.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      dark
      dense
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Trouver son cadeau - Admin</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <slot />
    </v-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ApplicationLayout',
  data() {
    return {
      drawer: null,
      globals: [
        {
          title: 'Products',
          icon: 'card_giftcard',
          route: 'home'
        },
        {
          title: 'Feeds',
          icon: 'rss_feed',
          route: 'feeds'
        }
      ],
      categorization: [
        {
          title: 'Tags',
          icon: 'local_offer',
          route: 'tags'
        },
        {
          title: 'Categories',
          icon: 'folder',
          route: 'categories'
        },
        {
          title: 'Pages',
          icon: 'description',
          route: 'pages'
        },
        {
          title: 'Brands',
          icon: 'view_module',
          route: 'brands'
        }
      ],
      admin: [
        {
          title: 'Configs',
          icon: 'build',
          route: 'configs'
        },
        {
          title: 'Menu',
          icon: 'menu',
          route: 'menu'
        },
        {
          title: 'Resellers',
          icon: 'local_mall',
          route: 'resellers'
        },
        {
          title: 'Users',
          icon: 'people_alt',
          route: 'users'
        }
      ]
    }
  },
  computed: {
    ...mapState('Global', [
      'account'
    ])
  },
  created() {
    this.$store.dispatch('Global/getAccount')
  },
  methods: {
    async logout() {
      await this.$auth.logout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
